import { createSlice } from '@reduxjs/toolkit';
import { IAction } from '../actionTypes';
import { IOrderReminder, OrderReminderFrequency } from '@protoplan/types';


export type TUserId = number | undefined;

export type UserState =
{
  userId: TUserId;
  username?: string | null;
  email?: string | null;
  countryId: number;
  currencyId: number,
  currencyCode: string;
  currencySymbol: string;
  salesTax: number;
  premium?: boolean;
  orderReminder: IOrderReminder
};

export interface UserUpdate
{
  userId?: number,
  username?: string,
  email?: string,
  countryId: number;
  currencyId: number;
  currencyCode: string;
  currencySymbol: string;
  salesTax?: number;
  premium?: boolean,
  orderReminder?: IOrderReminder
}

const defaultUser = {
  userId: undefined,
  username: undefined,
  email: undefined,
  countryId: 1,
  currencyId: 1,
  currencyCode: "GBP",
  currencySymbol: "£",
  salesTax: 0,
  premium: false,
  orderReminder: { active: false, frequency: OrderReminderFrequency.MONTHLY } };

export const userSlice = createSlice({
  name: 'User',
  initialState: defaultUser,
  reducers: {
    updateCurrentUser: (state: UserState, action: IAction<UserUpdate | undefined>) =>
    {
      state.userId = action.payload?.userId;
      state.username = action.payload?.username;
      state.email = action.payload?.email;
      state.countryId = action.payload?.countryId || defaultUser.countryId;
      state.currencyId = action.payload?.currencyId || defaultUser.currencyId;
      state.currencyCode = action.payload?.currencyCode || defaultUser.currencyCode;
      state.currencySymbol = action.payload?.currencySymbol || defaultUser.currencySymbol;
      state.salesTax = Number(action.payload?.salesTax) || defaultUser.salesTax;
      state.premium = action.payload?.premium;
      state.orderReminder = action.payload?.orderReminder || defaultUser.orderReminder;
    },
    updateCurrentCountry: (state: UserState, action: IAction<{
      countryId: number,
      currencyCode: string,
      currencySymbol: string }>) =>
    {
      state.countryId = action.payload.countryId;
      state.currencyCode = action.payload.currencyCode;
      state.currencySymbol = action.payload.currencySymbol;
    },
    updateOrderReminder: (state: UserState, action: IAction<IOrderReminder>) =>
    {
      if(action.payload.active !== undefined)
        state.orderReminder.active = action.payload.active;

      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      if((action.payload.active && !state.orderReminder.date) || action.payload.date !== undefined)
        state.orderReminder.date = (action.payload.date !== undefined) ? action.payload.date : tomorrow;

      if(action.payload.frequency)
        state.orderReminder.frequency = action.payload.frequency;
    }
  }
});

export const {
  updateCurrentUser,
  updateCurrentCountry,
  updateOrderReminder } = userSlice.actions;
export default userSlice.reducer;
